import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../api';
import { CreateAccountRequest } from './createaccountrequest';

export class CreateAccountAPI extends APIImpl<CreateAccountRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/registration
        return "registration";
    }
    
    getRequestData()
    {
         return "msisdn="+ this.getRequest().getCreateAccountRequest().getMsisdn()+"&"+
            "encryptedPassword="+ this.getRequest().getCreateAccountRequest().getEncryptedPassword()+"&"+
            "language="+ this.getRequest().getCreateAccountRequest().getLanguage()+"&"+
            "clientTxnId="+ this.getRequest().getCreateAccountRequest().getClientTxnId()+"&"+
            "userName="+ this.getRequest().getCreateAccountRequest().getUserName()+"&"+
            "email="+ this.getRequest().getCreateAccountRequest().getEmail()+"&"+
            "categoryId="+ this.getRequest().getCreateAccountRequest().getCategoryId()+"&"+
            "securityCounter="+ this.getRequest().getCreateAccountRequest().getSecurityCounter();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/createaccount/createaccountapi.tsx